import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerDialogService } from 'src/app/dialogs/customer/customer.service.dialog';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { Task, TaskStatus } from '@contracts/interfaces/task.interface';
import { CustomerService } from 'src/app/services/customer.service';
import { TaskService } from '../../services/task.service';

@Component({
  selector: 'ap-task-create',
  templateUrl: './task-create.component.html',
  styleUrls: ['./task-create.component.scss'],
})
export class TaskCreateComponent implements OnInit {

  newTask: Task = {
    id: 0,
    date: new Date(),
    type: '',
    status: TaskStatus.InProgress,
    customer: null,
    subject: '',
    description: '',
    dueDate: '',
    log: [],
    quote: 0
  }

  constructor(
    private taskService: TaskService, 
    private customerService: CustomerService, 
    private customerDialogService: CustomerDialogService,
    private router: Router) {

  }

  ngOnInit(): void {

  }

  createTask() {
    this.taskService.create(this.newTask).subscribe((r: any) => {
      this.router.navigate(["tasks", r.id]);
    });
  }





  public customers: CustomerInterface[] = [] as CustomerInterface[];
  isOpen = false;
  findCustomers(searchText: string) {
    // this.customerService.find({'$text': { $search: searchText }}, 1, 0).subscribe(r => {
    //   console.log(r);
    // })

    this.customerService.find({ 'name': { $regex: searchText, $options: 'i' } }, 1, 5).subscribe((r: CustomerInterface[] | any) => {
      this.customers = r;
    })
  }

  close() {
    this.isOpen = false;
    this.customers = [];
  }

  pickCustomer(customer: CustomerInterface) {
    this.newTask.customer = customer;
    this.close();
  }

  chooseDifferentCustomer() {
    this.newTask.customer = null;
    this.isOpen = !this.isOpen
  }

  createCustomer(customerName = "") {
    this.customerDialogService.launchDialog(null, customerName, (r: any) => {
      this.newTask.customer = r;
      this.isOpen = !this.isOpen;
    });
  }

  editCustomer() {
    this.customerDialogService.launchDialog(this.newTask.customer, null, (r: any) => {
      if (r != "" && r != undefined) {
        this.newTask.customer = r;
      }
    });
  }

  hasCustomer() {
    if (this.newTask.customer == null) {
      return false;
    } else {
      return true;
    }
  }


}
